module.exports = function getResource(label, vars = []) {
    const resources = {
        map: 'Plan',
        moreTimesLocations: 'Afficher plus d’heures et d’emplacements',
        milesAbbreviation: 'mi'
    };

    return resources[label];
};
